import classNames from 'classnames'
import React from 'react'
import { dangerCardHeader, infoCardHeader, primaryCardHeader, successCardHeader, warningCardHeader } from 'theme'

import { createStyles } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

export enum CardHeaderColor {
  primary = 'primary',
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
}

const CardHeader: React.SFC<CardHeaderPropsWithStyles> = ({ classes, className, children, color, plain, ...rest }) => {
  const cardHeaderColor =
    {
      [CardHeaderColor.warning]: classes.warningCardHeader,
      [CardHeaderColor.success]: classes.successCardHeader,
      [CardHeaderColor.danger]: classes.dangerCardHeader,
      [CardHeaderColor.info]: classes.infoCardHeader,
      [CardHeaderColor.primary]: classes.primaryCardHeader,
    }[color] || classes.primaryCardHeader

  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    [cardHeaderColor]: color !== undefined,
    [classes.cardHeaderPlain]: plain,
    [className]: className !== undefined,
  })
  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  )
}

type CardHeaderPropsWithStyles = CardHeaderProps & WithStyles<typeof styles>

type CardHeaderProps = {
  className: string
  color: CardHeaderColor
  plain?: boolean
}

const styles = () =>
  createStyles({
    cardHeader: {
      borderRadius: '3px',
      padding: '1rem 15px',
      marginLeft: '15px',
      marginRight: '15px',
      marginTop: '-30px',
      border: '0',
      marginBottom: '0',
    },
    cardHeaderPlain: {
      marginLeft: '0px',
      marginRight: '0px',
    },
    primaryCardHeader,
    infoCardHeader,
    successCardHeader,
    warningCardHeader,
    dangerCardHeader,
  })

export default withStyles(styles)(CardHeader)
